/**
 * @class CpfPipe
 *
 * @author Márcio Casale de Souza and modified by Leonardo Pliskieviski
 */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cpf',
})
export class CpfPipe implements PipeTransform {
  transform(cpf: string): string {
    if (!cpf) {
      return '';
    }

    const cpfValor = cpf.replace(/\D/g, '');

    if (cpfValor.length !== 11) {
      return cpf;
    }

    const cpfValuesArray = cpfValor.match(/^(\d{3})(\d{3})(\d{3})(\d{2})$/);

    if (cpfValuesArray && cpfValuesArray.length === 5) {
      cpf =
        cpfValuesArray[1] +
        '.' +
        cpfValuesArray[2] +
        '.' +
        cpfValuesArray[3] +
        '-' +
        cpfValuesArray[4];
    }

    return cpf;
  }
}
